<template>
    <div class="row">
        <div class="col-lg-12">
            <b-card :header="uLang('app.overview')" header-tag="h4" class="bg-default-card">

                <div>
                    <div class="pull-left">
                        <div class="p-2">
                            <span>{{ lang('app.rows_per_page_text') }} : </span>
                            <select class="rowsPerPageClass" name="rowsPerPage" id="rowsPerPage" v-model="rowsPerPage">
                                <option value="15">15</option>
                                <option value="30">30</option>
                                <option value="45">45</option>
                                <option value="60">60</option>
                                <option value="90">90</option>
                            </select>
                        </div>
                    </div>
                    <div class="pull-right mb-3">
                        <router-link class="btn btn-brand" :to="{ name: 'admin.organisations.create' }">{{ uLang('app.add_type', { type: lang('app.organisation') }) }}</router-link>
                    </div>
                </div>

                <table-admin-organisations :rows-per-page="rowsPerPage" />
            </b-card>
        </div>
    </div>
</template>

<script>
    import TableAdminOrganisation from '~/components/tables/admin/organisation/table'

    export default {
        name: 'index',

        data() {
            return {
                rowsPerPage: "15",
            }
        },

        components: {
            'table-admin-organisations': TableAdminOrganisation,
        },
    }
</script>

<style lang="css" scoped>
.rowsPerPageClass {
    display: inline-block;
    width: 100px;
    padding: 6px;
}
</style>